export const badgeStyle = {
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
  },
  '& .MuiBadge-badge': {
    backgroundColor: '#ff9800',
    color: '#fff',
    fontSize: '12px',
    fontWeight: 'bold',
    minWidth: '18px',
    height: '18px',
    padding: '0 4px',
  },
};

